<div class="onboarding-beneficiarios__container" *ngIf="!beneficiarioStatus">
  <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
  <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
  <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
  <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
</div>

<ng-container *ngIf="beneficiarioStatus">
  <div class="onboarding-beneficiarios__container">
    <app-onboarding-card
      imageUrl="../../../../../assets/images/group.png"
      title="Beneficiários"
      redirectTo="/beneficiarios"
      [checked]="beneficiarioStatus.beneficiario"
      [disabled]="false"
    ></app-onboarding-card>
  </div>

  <form class="d-flex justify-content-end" (ngSubmit)="onFinalize()">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!beneficiarioStatus.beneficiario"
    >
      Finalizar
    </button>
  </form>
</ng-container>
